export default "__VITE_ASSET__CWRvNsx3__"